import { render, staticRenderFns } from "./MinigamePage.vue?vue&type=template&id=779ba64d&scoped=true"
import script from "./MinigamePage.vue?vue&type=script&lang=js"
export * from "./MinigamePage.vue?vue&type=script&lang=js"
import style0 from "./MinigamePage.vue?vue&type=style&index=0&id=779ba64d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779ba64d",
  null
  
)

export default component.exports